import { UNIPROMEL_DOMAIN, OPENSALUD_MX_DOMAIN, OPENLEGAL_DOMAIN } from '@/constants/domains'
import { COMUNIDAD_SALUDABLE_SUBDOMAIN, OPENSALUD360_SUBDOMAIN, HEALTHY_HABITS_SUBDOMAIN } from '@/constants/subdomains'
import { ACCEPTANCE_COOKIE_NAME, MINIMUM_COOKIE_NAME } from '@/constants/cookies'
import { UNIPROMEL_LOGO, OPENSALUD360_LOGO, OPENLEGAL_LOGO, OPENSALUD_MX_LOGO, OPENSALUD_LOGO } from '@/constants/logosFileNames'
import { getSmartsuppKey } from '@/constants/vendorKeys'
import { getPlatformName, OPENLEGAL_PLATFORM_NAME, OPENSALUD_PLATFORM_NAME } from '@/constants/platformNames'
import CollapseTransition from '@/components/base/transitions/CollapseTransition'
import { WHITE_COLOUR } from '@/constants/colours'

export default {
  metaInfo () {
    return this.$helpers.buildMetaInfo({ appName:  this.getFavicon(), appTagLine: this.$route.meta.tagLine })
  },
	components: {
		CollapseTransition
	},
  data () {
    return {
			WHITE_COLOUR,
      logo: null,
			showServicesMenu: false
    }
  },
  methods: {
    getFavicon () {
      const platformName = getPlatformName()
      switch (platformName) {
        case OPENSALUD_PLATFORM_NAME:
          return 'opensalud'
        case OPENLEGAL_PLATFORM_NAME:
          return 'openlegal'
        default:
          return 'opensalud'
      }
    },
    loadScriptAsync: function (uri, id) {
      return new Promise((resolve, reject) => {
        if (!document.getElementById(id)) {
          var tag = document.createElement('script')
          tag.text = `var _smartsupp = _smartsupp || {}; _smartsupp.key = \'${getSmartsuppKey()}\';          window.smartsupp||(function(d) {            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];            s=d.getElementsByTagName(\'script\')[0];c=d.createElement(\'script\');            c.type=\'text/javascript\';c.charset=\'utf-8\';c.async=true;            c.src=\'https://www.smartsuppchat.com/loader.js?\';s.parentNode.insertBefore(c,s);          })(document);`
/*           tag.src = uri */
          tag.type = 'text/javascript'
          /* tag.async = true
          tag.defer = true */
          tag.setAttribute('id', id)
          tag.onload = () => {
            resolve()
          }
          document.head.appendChild(tag)
        } else {
          resolve()
        }
      })
    },
    getLogoFileName () {
      return window.location.hostname.includes(UNIPROMEL_DOMAIN) ? UNIPROMEL_LOGO : 
      (window.location.hostname.includes(`${OPENSALUD360_SUBDOMAIN}.`) ? OPENSALUD360_LOGO : 
      (window.location.hostname.includes(OPENLEGAL_DOMAIN) ? OPENLEGAL_LOGO : 
      (window.location.hostname.includes(OPENSALUD_MX_DOMAIN) ? OPENSALUD_MX_LOGO : OPENSALUD_LOGO)))
    },
		onTabClick (tab) {
			if (tab.href) {
				this.$helpers.goToWebApp(tab.href, this.$apiToken)
			} else if (tab.action) {
				tab.action()
			} else {
				this.$router.push(`/patient/${tab.path}`)
			}
		},
		toggleShowServicesMenu () {
			this.showServicesMenu = !this.showServicesMenu
		},
    goPatientMenu () {
			location.href = this.$store.getters['session/userHasCompanies'] ? this.$helpers.get360AppUrl('patient') : this.$helpers.getV2AppUrl('patient')
		},
    getLogoFileNameByUser () {
			return this.$store.getters['session/userHasCompanies'] ? OPENSALUD360_LOGO : window.location.hostname.includes(OPENSALUD_MX_DOMAIN) ? OPENSALUD_MX_LOGO : OPENSALUD_LOGO
		},
    inPatientsLikeYouOrHealthyHabitsDomain () {
      return window.location.hostname.includes(COMUNIDAD_SALUDABLE_SUBDOMAIN) || window.location.hostname.includes(HEALTHY_HABITS_SUBDOMAIN)
    }
  },
  mounted () {
    // Load only if any of acceptance cookies are enabled
    if (!!this.$cookies.get(ACCEPTANCE_COOKIE_NAME) || !!this.$cookies.get(MINIMUM_COOKIE_NAME)) {
      this.loadScriptAsync('../plugins/smartsuppChat.js', 'smartsupp-chat').then(() => {
        this.loading = false
				this.$store.state.smartsuppChatLoaded = true
      })
    }

    // Logo load
    this.logo = this.$route.meta.logo && this.$route.meta.logo.src ? require(`img/logos/${this.$route.meta.logo.src}`) : require(`img/logos/${this.inPatientsLikeYouOrHealthyHabitsDomain() ? this.getLogoFileNameByUser() : this.getLogoFileName()}`)
  },
  computed: {
    getLogo () {
      return this.logo
    },
    getLogoClasses () {
      return `navbar-brand-img ${(this.$route.meta.logo && this.$route.meta.logo.styleClasses ? this.$route.meta.logo.styleClasses : '')}`
    },
    getLogoStyles () {
      return this.$route.meta.logo ? this.$route.meta.logo.styles : [] || []
    },
    getMetaTitle () {
      return this.$helpers.getMetaTitleText(this.$route)
    },
		inPanel () {
			return this.$route.name === 'Panel'
		},
		showBackButton () {
			// Check if there is a previous route inside opensalud
			return !this.inPanel && window.history.length > 1
		},
		caretSubMenuClass () {
			return `caret-icon ${!this.showServicesMenu ? 'rotate-90' : 'rotate-270'}`
		},
  }
}


// WEBPACK FOOTER //
// ./src/mixins/layout.mixin.js